A short human-readable name for the workflow step.

This is non-null for a process history action of an uploaded candidate.
